import { render, staticRenderFns } from "./TopRated.vue?vue&type=template&id=582cb3fc"
import script from "./TopRated.vue?vue&type=script&lang=js"
export * from "./TopRated.vue?vue&type=script&lang=js"
import style0 from "./TopRated.vue?vue&type=style&index=0&id=582cb3fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports